import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { tabs, unoTheme } from '../../../../assets/styles/unoTheme';
import { Route, useHistory, Switch, useLocation } from 'react-router';
import { MyTabs, MyTab } from "../../../utils/MyTabs";
import ActionsHistory from './ActionsHistory';
import AccessHistory from './AccessHistory';
import ConciliationScreen from './ConciliationScreen';
import SearchBar from '../../../utils/SearchBar';
import menuItems from '../../../dashboard/menuItems';
import { path } from '../../../utils/routesPaths';
import MyAutoComplete from '../../../utils/MyAutoComplete';
import { ClientAPI } from '../../../../API/client';
import ClientUpdateLogs from './ClientUpdateLogs';
import ComdinheiroReqsLogs from './ComdinheiroReqsLogs';
import PortfolioChangesLogs from './PortfolioChangesLogs';
import MyDatePicker from '../../../utils/MyDatePicker';
import MySelect from '../../../utils/MySelect';
import UsageRanking from './UsageRanking';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  },
  green: {
    color: 'green'
  },
  red: {
    color: 'red',
  },
  tabs: tabs,
  shortWidthTab: {
    '& .MuiTab-root': {
      minWidth: '100px !important',
      width: 'auto',
    }
  },
  // Abas roláveis: com muitas abas + filtros, as setas aparecem só quando não cabe tudo na linha
  // (o cabeçalho tem que ficar em uma linha: a área da tabela desconta 72px fixos)
  scrollableTabs: {
    '& .MuiTabs-scroller': {
      display: 'flex',
    },
    '& .MuiTabs-scrollButtons': {
      width: '32px',
      color: unoTheme.mainColor,
    },
  },
  tabsWithRight: {
    display: 'flex',
    flexDirection: 'row',
    paddingRight: theme.spacing(2),
    alignItems: 'center',

    // Só as abas (primeiro filho) encolhem e rolam; os filtros mantêm a largura
    '& > *:not(:first-child)': {
      flexShrink: 0,
    },

    '& .MuiToggleButtonGroup-root': {
      alignItems: 'center',

      '& .MuiToggleButton-label': {
        whiteSpace: 'nowrap'
      }
    }
  },
  // Form
  inputSearch: {
    width: "300px",
    background: "white"
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  toStickyHeader: {
    display: 'flex',
    height: '100%',
  },
  comdinheiroFilters: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flex: 1,
  },
  datePickerWrapper: {
    minWidth: '175px',
    flex: 1,
    maxWidth: '220px',
    '& .MuiTextField-root': {
      width: '100% !important',
      margin: '0 !important',
    },
  },
  myDatePicker: {
    marginTop: '-6px',
  },
  // Filtro de largura fixa (a largura vem por style): sem ela, o input encolhe até sumir
  fixedFilter: {
    flexShrink: 0,
    '& .MuiTextField-root, & .MuiFormControl-root': {
      width: '100% !important',
    },
  },
}));

export default function LogsScreen({
  setShowMonths,
  setShowYears,
  locationOnScreen,
  setLocationOnScreen
}) {

  const classes = useStyles();
  const [tabValue, setTabValue] = useState(0);
  const tabsRef = useRef(null);

  // Cada aba tem filtros de largura diferente, então a barra de abas muda de largura na troca e o
  // scroll automático do MUI (animado e calculado antes disso) pode deixar a aba selecionada fora
  // de vista. Aqui o DOM já está com os filtros da nova aba: rola na hora, antes da pintura
  useLayoutEffect(() => {
    const selectedTab = tabsRef.current && tabsRef.current.querySelector('.Mui-selected');
    if (selectedTab) {
      selectedTab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  }, [tabValue]);
  const [search, setSearch] = useState('');
  const history = useHistory();
  const location = useLocation();


  const [allClients, setAllClients] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const handleChangeClient = (event, newValue) => {
    setSelectedClient(newValue)
  };

  // Filtros Reqs. Comdinheiro
  const [comdinheiroDateStart, setComdinheiroDateStart] = useState(null);
  const [comdinheiroDateEnd, setComdinheiroDateEnd] = useState(null);
  const [comdinheiroUserSearch, setComdinheiroUserSearch] = useState('');

  // Filtros Alterações da carteira
  const [changesDateStart, setChangesDateStart] = useState(null);
  const [changesDateEnd, setChangesDateEnd] = useState(null);

  // Filtros da assiduidade: padrão são os últimos 12 meses
  const [usageDateStart, setUsageDateStart] = useState(moment().subtract(1, 'year').add(1, 'day'));
  const [usageDateEnd, setUsageDateEnd] = useState(moment());
  const [usageView, setUsageView] = useState('clients');

  // Filtros dos acessos
  const [accessDateStart, setAccessDateStart] = useState(null);
  const [accessDateEnd, setAccessDateEnd] = useState(null);

  const ACCESSES_TAB = 3;
  const PORTFOLIO_CHANGES_TAB = 5;
  const USAGE_TAB = 6;

  const handleChangeTabValue = (event, newTabValue) => {

    setTabValue(newTabValue);

    const HISTORY = {
      comdinheiroReqs: 0,
      clientUpdates: 1,
      actions: 2,
      accesses: 3,
      conciliations: 4,
      portfolioChanges: PORTFOLIO_CHANGES_TAB,
      usage: USAGE_TAB
    };

    switch (newTabValue) {
      case HISTORY.comdinheiroReqs:
        history.push('/administration/logs/comdinheiroReqs');
        break;
      case HISTORY.clientUpdates:
        history.push('/administration/logs/clientUpdates');
        break;
      case HISTORY.actions:
        history.push('/administration/logs/actions');
        break;
      case HISTORY.accesses:
        history.push('/administration/logs/accesses');
        break;
      case HISTORY.conciliations:
        history.push('/administration/logs/conciliations');
        break;
      case HISTORY.portfolioChanges:
        history.push('/administration/logs/portfolioChanges');
        break;
      case HISTORY.usage:
        history.push(path.administration.logs.usage);
        break;
      default:
        break;
    }
  };

  async function loadAllClients() {

    const responseAllClients = await ClientAPI.listAllClients();
    if (responseAllClients.success) {
      setAllClients(responseAllClients.body.rows);
    } else {
      setAllClients([])
    }


  }

  useEffect(() => {
    // if ((location && !locationOnScreen)
    //   || (location && location.pathname != locationOnScreen.pathname)) {
    //   const isUserFirstTimeOnScreen = location.pathname === path.administration.logs.root;
    //   if (isUserFirstTimeOnScreen) {
    //     setShowMonths(false);
    //     setShowYears(false);
    //   };
    //   redirect();
    //   setLocationOnScreen(location);
    // }

    if (!allClients) {
      loadAllClients();
    }
  }, [location])

  return (
    <div className={classes.root}>

      <div className={classes.tabsWithRight}>
        <div ref={tabsRef} className={[classes.tabs, classes.shortWidthTab, classes.scrollableTabs].join(' ')} style={{ flex: '0 1 auto', width: 'auto', minWidth: 0 }}>
          <MyTabs
            variant="scrollable"
            // "on" e não "auto": no "auto" as setas entram e saem do layout e mudam a largura da barra
            // depois que o MUI rolou a aba selecionada, que acaba fora de vista. Desabilitada, a seta fica invisível
            scrollButtons="on"
            value={tabValue}
            indicatorColor="primary"
            textColor="primary"
            onChange={handleChangeTabValue}
            aria-label="disabled tabs example"
          >
            <MyTab label="Comdinheiro" />
            <MyTab label="Cliente" />
            <MyTab label="Ações" />
            <MyTab label="Acessos" />
            <MyTab label="Conciliações" />
            <MyTab label="Alterações" />
            <MyTab label="Assiduidade" />
          </MyTabs>
        </div>

        {
          tabValue == 0 ?
            <div className={classes.comdinheiroFilters}>
              {/* Filtros req comdinheiro */}
              <div className={classes.datePickerWrapper}>
                <MyDatePicker
                  margin="dense"
                  inputVariant="outlined"
                  label="De"
                  format="DD/MM/YYYY"
                  value={comdinheiroDateStart}
                  onChange={(value) => setComdinheiroDateStart(value ? moment(value) : null)}
                  KeyboardButtonProps={{ 'aria-label': 'change date' }}
                  clearable
                />
              </div>
              <div className={classes.datePickerWrapper}>
                <MyDatePicker
                  margin="dense"
                  inputVariant="outlined"
                  label="Até"
                  format="DD/MM/YYYY"
                  value={comdinheiroDateEnd}
                  onChange={(value) => setComdinheiroDateEnd(value ? moment(value) : null)}
                  KeyboardButtonProps={{ 'aria-label': 'change date' }}
                  clearable
                />
              </div>
              <div className={classes.fixedFilter} style={{ width: '200px' }}>
                <SearchBar
                  name='search_user'
                  mask='text'
                  size='small'
                  variant='outlined'
                  label='Usuário'
                  setSearchQuery={setComdinheiroUserSearch}
                />
              </div>
            </div> : null
        }

        {
          tabValue == PORTFOLIO_CHANGES_TAB ?
            <div className={classes.comdinheiroFilters}>
              {/* Filtros das alterações da carteira: o período filtra a data da alteração */}
              <div className={classes.datePickerWrapper}>
                <MyDatePicker
                  margin="dense"
                  inputVariant="outlined"
                  label="De"
                  format="DD/MM/YYYY"
                  value={changesDateStart}
                  onChange={(value) => setChangesDateStart(value ? moment(value) : null)}
                  maxDate={changesDateEnd || undefined}
                  KeyboardButtonProps={{ 'aria-label': 'change date' }}
                  clearable
                />
              </div>
              <div className={classes.datePickerWrapper} style={{ marginRight: '8px' }}>
                <MyDatePicker
                  margin="dense"
                  inputVariant="outlined"
                  label="Até"
                  format="DD/MM/YYYY"
                  value={changesDateEnd}
                  onChange={(value) => setChangesDateEnd(value ? moment(value) : null)}
                  minDate={changesDateStart || undefined}
                  KeyboardButtonProps={{ 'aria-label': 'change date' }}
                  clearable
                />
              </div>
            </div> : null
        }

        {
          tabValue === ACCESSES_TAB ?
            <div className={classes.comdinheiroFilters} style={{ flex: 'none' }}>
              {/* Filtros dos acessos: o período filtra a data do login */}
              <div className={classes.datePickerWrapper}>
                <MyDatePicker
                  margin="dense"
                  inputVariant="outlined"
                  label="De"
                  format="DD/MM/YYYY"
                  value={accessDateStart}
                  onChange={(value) => setAccessDateStart(value ? moment(value) : null)}
                  maxDate={accessDateEnd || undefined}
                  KeyboardButtonProps={{ 'aria-label': 'change date' }}
                  clearable
                />
              </div>
              <div className={classes.datePickerWrapper} style={{ marginRight: '8px' }}>
                <MyDatePicker
                  margin="dense"
                  inputVariant="outlined"
                  label="Até"
                  format="DD/MM/YYYY"
                  value={accessDateEnd}
                  onChange={(value) => setAccessDateEnd(value ? moment(value) : null)}
                  minDate={accessDateStart || undefined}
                  KeyboardButtonProps={{ 'aria-label': 'change date' }}
                  clearable
                />
              </div>
            </div> : null
        }

        {
          tabValue === USAGE_TAB ?
            <div className={classes.comdinheiroFilters}>
              {/* Filtros da assiduidade: o período é obrigatório, por isso sem clearable */}
              <div className={classes.datePickerWrapper}>
                <MyDatePicker
                  margin="dense"
                  inputVariant="outlined"
                  label="De"
                  format="DD/MM/YYYY"
                  value={usageDateStart}
                  onChange={(value) => value && setUsageDateStart(moment(value))}
                  maxDate={usageDateEnd}
                  KeyboardButtonProps={{ 'aria-label': 'change date' }}
                />
              </div>
              <div className={classes.datePickerWrapper}>
                <MyDatePicker
                  margin="dense"
                  inputVariant="outlined"
                  label="Até"
                  format="DD/MM/YYYY"
                  value={usageDateEnd}
                  onChange={(value) => value && setUsageDateEnd(moment(value))}
                  minDate={usageDateStart}
                  maxDate={moment()}
                  KeyboardButtonProps={{ 'aria-label': 'change date' }}
                />
              </div>
              <div className={classes.fixedFilter} style={{ width: '150px' }}>
                <MySelect
                  customWidth={'150px'}
                  value={usageView}
                  onChange={(e) => setUsageView(e.target.value)}
                  options={[
                    <option key={'usage-view-clients'} value={'clients'}>Por cliente</option>,
                    <option key={'usage-view-users'} value={'users'}>Por usuário</option>,
                  ]}
                />
              </div>
            </div> : null
        }

        {
          tabValue == 1 || tabValue == 2 || tabValue === ACCESSES_TAB || tabValue == PORTFOLIO_CHANGES_TAB ?
            <>

              {
                allClients ?
                  <MyAutoComplete
                    options={allClients}
                    autoComplete
                    customWidth={'300px'}
                    // customPadding={'6px 16px'}
                    // customHeight={'25px'}
                    value={
                      selectedClient
                    }
                    onChange={(event, newValue) => {
                      handleChangeClient(event, newValue)
                    }}
                    label={"Filtrar por cliente"}
                    getOptionLabel={(option) => option.label_name}
                    getOptionSelected={(option, value) => option.id === value.id}
                    renderOption={(option) => (
                      <React.Fragment key={'autocomplete-' + option.id}>
                        <span>{option.label_name}</span>
                      </React.Fragment>
                    )}
                  /> : null
              }

            </>
            : null
        }

        {
          tabValue === ACCESSES_TAB || tabValue === 4 ?
            <div className={classes.fixedFilter} style={{ width: '200px', marginLeft: tabValue === ACCESSES_TAB ? '8px' : 0 }}>
              <SearchBar
                name='search_query'
                mask='text_cpf'
                size='small'
                variant='outlined'
                label='Nome ou CPF'
                setSearchQuery={setSearch}
              />
            </div>
            : null
        }


        {/* <MyTooltip
          hasAlert
          alertMessage={<CPF_AND_NAME_TEXT searchColumnTitle="usuário" />}
          tooltipTitle="Como funciona a busca?"
        /> */}
      </div>

      <Switch>
        <Route path="/administration/logs/comdinheiroReqs">
          <ComdinheiroReqsLogs
            dateStart={comdinheiroDateStart}
            dateEnd={comdinheiroDateEnd}
            userSearch={comdinheiroUserSearch}
          />
        </Route>
        <Route path="/administration/logs/clientUpdates">
          <ClientUpdateLogs selectedClient={selectedClient} />
        </Route>
        <Route path="/administration/logs/actions">
          <ActionsHistory selectedClient={selectedClient} />
        </Route>
        <Route path="/administration/logs/accesses">
          <AccessHistory
            search={search}
            selectedClient={selectedClient}
            dateStart={accessDateStart}
            dateEnd={accessDateEnd}
          />
        </Route>
        <Route path="/administration/logs/conciliations">
          <ConciliationScreen search={search} />
        </Route>
        <Route path="/administration/logs/portfolioChanges">
          <PortfolioChangesLogs
            selectedClient={selectedClient}
            dateStart={changesDateStart}
            dateEnd={changesDateEnd}
          />
        </Route>
        <Route path={path.administration.logs.usage}>
          <UsageRanking
            startDate={usageDateStart && usageDateStart.isValid() ? usageDateStart.format('YYYY-MM-DD') : null}
            endDate={usageDateEnd && usageDateEnd.isValid() ? usageDateEnd.format('YYYY-MM-DD') : null}
            view={usageView}
          />
        </Route>
      </Switch>
    </div >
  );
}






